import { createFeatureSelector, MemoizedSelector } from '@ngrx/store';
import { COMPANY_FEATURE, CompanyState, StateWithCompany } from '../company-state';

export const getCompanyState: MemoizedSelector<StateWithCompany, CompanyState> =
  createFeatureSelector<CompanyState>(COMPANY_FEATURE);
